import getClassNames from 'classnames';
import React, { Component, PropTypes } from 'react';

class Counter extends Component {

  render() {
    const { data, style = {} } = this.props;

    const dataClasses = getClassNames('counter', {
      'is-zero': data === 0,
    });

    return (
      <div style={style} className={dataClasses}>{data}</div>
    );
  }
}

Counter.propTypes = {
  data: PropTypes.number,
  style: PropTypes.object,
};

export default Counter;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/counter.jsx